// Viewport
export const SET_VIEWPORT = 'viewport/SET_VIEWPORT';
export const SET_PAGE_VISIBILITY = 'viewport/SET_PAGE_VISIBILITY';

// Scroll
export const SET_SCROLL = 'scroll/SET_SCROLL';
export const DISABLE_SCROLL = 'scroll/DISABLE_SCROLL';

// Page events
export const SET_PAGE_LOADING = 'page/SET_PAGE_LOADING';
export const SET_PAGE_LANGUAGE_SIBLINGS = 'page/SET_PAGE_LANGUAGE_SIBLINGS';
export const SET_PAGE_CONTAINERS = 'page/SET_PAGE_CONTAINERS';
export const SET_PAGE_THEME = 'page/SET_PAGE_THEME';

// Lateral menu events
export const SET_LATERAL_MENU = 'menu/SET_LATERAL_MENU';


